import Axios from '../../library/Axios'

export const ProductViewAction = (id: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'PRODUCT_VIEW_REQUEST' })

        const { data } = await new Axios().get(`/get/product/${id}`)

        dispatch({ type: 'PRODUCT_VIEW_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'PRODUCT_VIEW_ERROR' })
    } finally {
        // dispatch({ type: 'PRODUCT_VIEW_RESET' })
    }
}

export const CartGetAction = () => async (dispatch: any) => {
    try {
        dispatch({ type: 'CART_GET_REQUEST' })

        const { data } = await new Axios().get(`/get/cart`)

        dispatch({ type: 'CART_GET_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'CART_GET_ERROR' })
    } finally {
        dispatch({ type: 'CART_GET_RESET' })
    }
}

export const ProductCommentsAction = (id: string, page: number = 0) => async (dispatch: any) => {
    try {
        dispatch({ type: 'PRODUCT_COMMENTS_REQUEST' })

        const { data } = await new Axios().get(`/get/product/${id}/comments/${page}`)

        dispatch({ type: 'PRODUCT_COMMENTS_SUCCESS', payload: data })
    } catch (error) {
        // console.log(error)
    }
}

export const AddCartPostAction = (product_id: number, color_id: number, quantity: number) => async (dispatch: any) => {
    try {
        dispatch({ type: 'ADD_CART_POST_REQUEST' })

        const { data } = await new Axios().post(`/post/cart/add`, {
            product_id: product_id,
            color_id: color_id,
            quantity: quantity
        })

        dispatch({ type: 'ADD_CART_POST_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'ADD_CART_POST_ERROR' })
    } finally {
        dispatch({ type: 'ADD_CART_POST_RESET' })
    }
}

export const RemoveCartPostAction = (product_id: number, color: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'REMOVE_CART_POST_REQUEST' })

        const { data } = await new Axios().post(`/post/cart/remove`, {
            product_id: product_id,
            color: color
        })

        dispatch({ type: 'REMOVE_CART_POST_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'REMOVE_CART_POST_ERROR' })
    } finally {
        dispatch({ type: 'REMOVE_CART_POST_RESET' })
    }
}

export const ChangeCartPostAction = (product_id: number, color: string, quantity: number) => async (dispatch: any) => {
    try {
        dispatch({ type: 'CHANGE_CART_POST_REQUEST' })

        const { data } = await new Axios().post(`/post/cart/change`, {
            product_id: product_id,
            color: color,
            quantity: quantity
        })

        dispatch({ type: 'CHANGE_CART_POST_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'CHANGE_CART_POST_ERROR' })
    } finally {
        dispatch({ type: 'CHANGE_CART_POST_RESET' })
    }
}

export const ApplyCouponPostAction = (coupon_code: string, province: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'APPLY_COUPON_POST_REQUEST' })

        const { data } = await new Axios().post(`/post/cart/coupon/apply`, {
            coupon_code: coupon_code,
            province: province
        })

        dispatch({ type: 'APPLY_COUPON_POST_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'APPLY_COUPON_POST_ERROR' })
    } finally {
        dispatch({ type: 'APPLY_COUPON_POST_RESET' })
    }
}

export const SubmitCartPostAction = (full_name: string, province: string, city: string, address: string, postal_code: string, telephone: string, mobile: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'SUBMIT_CART_POST_REQUEST' })

        const { data } = await new Axios().post(`/post/cart/submit`, {
            full_name: full_name,
            province: province,
            city: city,
            address: address,
            postal_code: postal_code,
            telephone: telephone,
            mobile: mobile
        })

        dispatch({ type: 'SUBMIT_CART_POST_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'SUBMIT_CART_POST_ERROR' })
    } finally {
        dispatch({ type: 'SUBMIT_CART_POST_RESET' })
    }
}

export const AddReminderPostAction = (product_id: number, color_id: number) => async (dispatch: any) => {
    try {
        dispatch({ type: 'ADD_REMINDER_POST_REQUEST' })

        const { data } = await new Axios().post(`/post/product/add_reminder`, {
            product_id: product_id,
            color_id: color_id
        })

        dispatch({ type: 'ADD_REMINDER_POST_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'ADD_REMINDER_POST_ERROR' })
    } finally {
        dispatch({ type: 'ADD_REMINDER_POST_RESET' })
    }
}